import OnSuccessDelegate from '../../types/OnSuccessDelegate'
import { Dispatch } from 'react'
import { BasicsState } from './store/State'
import {
  BasicsAction,
  setResponse,
  addSchool,
  setSchoolResponse,
  setIsSearchingSchool,
  setSchoolSearchResult
} from './store/Actions'
import { IResponseUpdateRequestPayload, IResponsesValue } from 'types'
import apiUrlsAddresses from 'config/constants/api-urls-addresses'
import { Http } from 'lib'
import { isEqual } from 'lodash'

export default class BasicsService {
  static handleUpdateResponse(
    state: BasicsState['user'],
    updateResponse: OnSuccessDelegate<IResponseUpdateRequestPayload>
  ) {
    return ({ response, questionKey }: IResponseUpdateRequestPayload) => {
      if (state[questionKey] !== response) {
        updateResponse({ questionKey, response })
      }
    }
  }

  static handleChangeResponse(dispatch: Dispatch<BasicsAction>) {
    return ({ questionKey, response }: IResponseUpdateRequestPayload) => {
      dispatch(setResponse({ questionKey, response }))
    }
  }

  static handleChangeSchool(dispatch: Dispatch<BasicsAction>) {
    return ({ index, schoolUpdates }: any) => {
      dispatch(setSchoolSearchResult([]))
      dispatch(setSchoolResponse({ index, schoolUpdates }))
    }
  }

  static handleUpdateSchool(
    state: BasicsState,
    responses: IResponsesValue,
    updateResponse: OnSuccessDelegate<IResponseUpdateRequestPayload>
  ) {
    return (index: number) => {
      if (!isEqual(state.user?.schools?.[index], responses?.schools?.[index])) {
        updateResponse({ questionKey: 'schools', response: state.user.schools })
      }
    }
  }

  static handleAddSchool(dispatch: Dispatch<BasicsAction>) {
    return () => {
      dispatch(addSchool())
    }
  }

  static handleRemoveSchool(
    dispatch: Dispatch<BasicsAction>,
    state: BasicsState,
    updateResponse: OnSuccessDelegate<IResponseUpdateRequestPayload>
  ) {
    return (index: number) => {
      const schools = state.user.schools.filter((_elm, i) => i !== index)
      updateResponse({ questionKey: 'schools', response: schools })
      dispatch(setResponse({ questionKey: 'schools', response: schools }))
    }
  }

  static handleSearchSchool(dispatch: Dispatch<BasicsAction>, onError: (error: string) => void) {
    return async (name: string) => {
      dispatch(setIsSearchingSchool(true))

      const [response, , error] = await BasicsService.getSchools(name)

      dispatch(setIsSearchingSchool(false))

      if (error) {
        onError(error)
        return
      } else {
        dispatch(
          setSchoolSearchResult(
            response.data.map((school: { _id: string; name: string }) => ({ value: school._id, label: school.name }))
          )
        )
      }
    }
  }

  static handleAddNewSchool(dispatch: Dispatch<BasicsAction>, onError: (error: string) => void) {
    return async (index: number, name: string) => {
      dispatch(setIsSearchingSchool(true))

      const [response, , error] = await BasicsService.addSchool(name)

      dispatch(setIsSearchingSchool(false))

      if (!error) {
        dispatch(
          setSchoolResponse({
            index,
            schoolUpdates: { schoolName: response?.data?.name, schoolId: response?.data?._id }
          })
        )
      } else {
        onError(error)
      }
    }
  }

  static async getSchools(name?: string): Promise<[any | null, number, string | null]> {
    return Http.get<any>(apiUrlsAddresses.schools.get(name))
  }

  static async addSchool(name: string): Promise<[any | null, number, string | null]> {
    return Http.post<{ name: string }, any>(apiUrlsAddresses.schools.create(), { name })
  }
}
